import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../environments/environment';
import { ResponseBaseI } from '../../models/responseBase.interface';


@Injectable({
  providedIn: 'root'
})
export class ParametricListsService {

  URI = environment.urlAPI;

  constructor(
    private http: HttpClient
  ) { }

  getDataLists(code: any) {
    return this.http.get<ResponseBaseI>(`${this.URI}/ParametroDetalle/PorCodigoInterno/${code}`);
  }

  getDataListDetail(string: any, code: any) {
    return this.http.get<ResponseBaseI>(`${this.URI}/ParametroDetalle/PorCodigoInternoIdPadre/${string}/${code}`);
  }
}
